import { render, staticRenderFns } from "./ChatsHelexium.vue?vue&type=template&id=2c0f2825&scoped=true"
import script from "./ChatsHelexium.vue?vue&type=script&lang=js"
export * from "./ChatsHelexium.vue?vue&type=script&lang=js"
import style0 from "./ChatsHelexium.vue?vue&type=style&index=0&id=2c0f2825&prod&lang=css"
import style1 from "./ChatsHelexium.vue?vue&type=style&index=1&id=2c0f2825&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0f2825",
  null
  
)

export default component.exports